import { Table as RACTable, TableProps } from "react-aria-components";
import { tableStyles } from "./tables.css";

const Table = ({ children, ...props }: TableProps) => (
  <RACTable className={tableStyles} {...props}>
    {children}
  </RACTable>
);

export default Table;
